import React from 'react'
import cn from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'

const style = {
  root: {
    width: '14px',
    height: '20px',
  },
}

const CursorIcon = ({ classes, className, ...props }) => (
  <SvgIcon
    {...props}
    className={cn(classes.root, className)}
    fill="none"
    viewBox="0 0 14 21"
  >
    <svg fill="none">
      <path
        d="M3.08176 0.851562C2.34281 6.86981 1.51184 13.1548 0.863281 18.3995C2.32705 17.6 3.78547 16.7908 5.24561 15.9848C5.68245 17.6208 6.11926 19.2569 6.55611 20.8929C7.73884 20.5749 8.98862 20.2388 10.0121 19.9636C9.576 18.3301 9.13985 16.6967 8.7037 15.0633C10.3726 15.0381 12.0415 15.0147 13.7103 14.9864C10.0331 10.0936 6.24842 5.05705 3.08176 0.851562Z"
        fill="#004360"
      />
    </svg>
  </SvgIcon>
)

export default withStyles(style)(CursorIcon)
